import {rankWith, isMultiLineControl } from '@jsonforms/core';

export default rankWith(11, isMultiLineControl);

